__turbopack_context__.v({
  "wrapper": "partner-module__6d5VQG__wrapper",
});
